import useApiMutation from './useApiMutation';

function useDeleteMeMutation(options) {
  return useApiMutation('delete', `/v1/me`, options);
}

export default useDeleteMeMutation;
